// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-entry[data-v-05fa9a4a]{padding:0 0 15px 0;display:flex;align-items:center}.settings-entry button[data-v-05fa9a4a]{margin-left:15px}`, "",{"version":3,"sources":["webpack://./src/components/SettingsInputFile.vue"],"names":[],"mappings":"AACA,iCACC,kBAAA,CACA,YAAA,CACA,kBAAA,CAEA,wCACC,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
